<template>
    <div>
        <base_aggregator
            @edit_location="edit_location"
            @get_json="get_json"
            @show_menu="show_menu"
            @make_sync="make_sync"
            @add_location="add_location"
            @head_action="head_action"
            :provider_id=this.provider_id
            provider_type="uber"
        />

        <uber_location_modal></uber_location_modal>
    </div>
</template>

<script>

import base_aggregator from "../base/base_aggregator";
import uber_location_modal from "./location/uber_location_modal";
import {mapGetters} from "vuex";

export default {
    name: "uber_export",
    components: {base_aggregator,uber_location_modal},
    props : {
        provider_id: {
            type: Number,
            required: true,
        },
    },
    created() {
        EventBus.$on('loaded_api',this.load_provider);
        EventBus.$on('reload_provider',this.load_provider);

        if(window.hasOwnProperty('agr_api')) {
            this.load_provider();
        }
    },

    methods: {
        head_action() {
            this.add_uber_token();
        },

        async add_uber_token() {
            await api.get('/internal/oauth/uber/redirect').then(({data}) => {
                if(data.status == "operation_success") {
                    let resp = data.data;
                    if(resp.hasOwnProperty("redirect")) {
                        window.open(resp.redirect);
                    }
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        /*async add_uber_client_token() {
            await api.get('/internal/uber/get_client_key').then(({data}) => {
                if(data.status == "operation_success") {
                    let resp = data.data;
                    if(resp.hasOwnProperty("redirect")) {
                        window.open(resp.redirect);
                    }
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },*/

        make_sync(location) {

        },

        show_menu(location) {
            window.open("/uber/" + location.id + "/preview");
        },

        get_json(location) {
            window.open("/internal/uber/restaurants/" + location.id + "/json");
        },


        edit_location(location) {
            EventBus.$emit("location_edit",{
                'org_id' : 0,
                'org_obj' : null,
                'location_id' : location.id,
                'provider_id' : this.provider_id
            });
        },

        add_location(organization) {

            EventBus.$emit("location_edit",{
                'org_id' : organization.id,
                'org_obj' : organization,
                'location_id' : 0,
                'provider_id' : this.provider_id
            });
        },

        load_provider() {
            this.$store.dispatch('aggregator/LOAD_OUT_PROVIDER',this.provider_id);
        }
    },

    computed : {

        ...mapGetters({
            'aggregator'        : "aggregator/getAggregator",
            'is_load_complete'  : "aggregator/is_load_complete"
        }),
    }
}
</script>

<style scoped>

</style>
